import { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';


import productApi from "../../api/productApi";
import virtualApi from "../../api/virtualApi";
import useMount from '../../hooks/useMount';
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import useAccess from "../../hooks/useAccess";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import BackButton from "../Commons/BackButton";
import useLog from "../../hooks/useLog";


import { getLabel, getLanguage } from "../../tools/Dictionary";

import "./Troubleshoot.css";

const TroubleshootVirtual = (props) =>
{

  //Logs
  const { logPageView } = useLog();

  //Query
  let [searchParam] = useSearchParams();

  //Navigation
  //const Navigate = useNavigate();


  //Props
  const IsDesktop = props.IsDesktop;

  //Redux
  const Dispatch = useDispatch();
  const Access = useAccess(["Trouble"]);

  //State
  const [id, setId] = useState(undefined);
  const [product, setProduct] = useState(undefined);
  const [url, setUrl] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  useEffect(() =>
  {
    if (product)
      logPageView("Troubleshoot Virtual Assitant", { productId: product._id, productCode: product.code });
  }, [product, logPageView]);

  useMount(() =>
  {
    Dispatch(setCurrentNavigation("TroubleProductVirtual"));
    loadData();
  }, []);


  const loadData = async (_showLoading = true) =>
  {

    try
    {

      let currentProduct = {
        _id: searchParam.get('product'),
      };


      //Get product data from the storage
      const storageProduct = JSON.parse(localStorage.getItem("product"));


      if (_showLoading)
      {
        setLoading(true);
      }

      let dataProduct = undefined;

      //If no storage data, if they product is not the same or if it has been loaded more than 10 minutes ago, load from the api. Otherwise load from storage.
      if (!storageProduct || storageProduct._id != currentProduct._id || new Date().getTime() - storageProduct.timestamp >= 600000)
      {

        let [productResponse] = await Promise.all([
          productApi.getProduct(currentProduct._id)
        ]);

        if (!productResponse.Success) throw new Error(productResponse.Error.label);

        dataProduct = productResponse.Data;


      } else
      {


        dataProduct = storageProduct;



      }

      setProduct(dataProduct);


      //Get a public session token from our backend (it exchanges our chatbot API key with Mosaic server-side, the key never reaches the browser)
      let sessionResponse = await virtualApi.getPublicSession(dataProduct._id);

      if (!sessionResponse.Success) throw new Error(sessionResponse.Error.label);

      const { public_session_token, agent_id, tenant_id } = sessionResponse.Data;

       //decide between "fr" and "en"
      const lang = getLanguage().code === 'FR' ? 'fr' : 'en';

      const tempUrl = `https://api.mosaic-ai.ca/api/v1/chatbot/widget/${agent_id}?tenant_id=${tenant_id}&lang=${lang}&theme=mosaic&voice=true#public_session_token=${encodeURIComponent(public_session_token || '')}`;

      setUrl(tempUrl);


      //setLoading(false);

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };



  if (!Access.canRead)
    return (
      <div className="page_cont">
        <div className="page_message_text">
          {getLabel("App", "Access Denied: You don't have...")}
        </div>
      </div>
    );



  return (
    <div className="page_body_cont" style={{ justifyContent: "center", alignItems: "center", height: "100%" }}>
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      <BackButton
        Hide={IsDesktop}
      />
<div
  className="troubleshoot_chat_cont"

  style={{
    width: "99%",
    height: 600,
    overflow: "hidden" // this is fine on the wrapper if you want to hide outer overflow
  }}
>
  <iframe
    src={url}
    title="Troubleshoot Content"
    style={{
      width: "100%",
      height: "100%",
      border: "none",
      // IMPORTANT: allow scrolling inside the iframe viewport
      overflow: "auto",
      display: "block" // avoid stray inline gap
    }}
    allow="microphone; camera; fullscreen; display-capture"
    sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
    // remove the scrolling attribute entirely
    onLoad={() => setLoading(false)}
  />
</div>
    </div>
  );

};

export default TroubleshootVirtual